module.exports = __webpack_public_path__ + "static/media/team.99d1ce47.jpg";